interface QRCodeProps {
  url?: string;
  size?: number;
  showDownload?: boolean;
}

export default function QRCode({ 
  url = `${window.location.origin}/qr`, 
  size = 300,
  showDownload = true 
}: QRCodeProps) {
  const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(url)}`;

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = qrCodeUrl;
    link.download = 'fluffy-pets-qr-code.png';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="relative inline-block">
      {/* Decorative circles */}
      <div className="absolute -top-4 -left-4 w-24 h-24 bg-teal-200 rounded-full opacity-50 animate-pulse"></div>
      <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-orange-200 rounded-full opacity-50 animate-pulse" style={{ animationDelay: '1s' }}></div>
      
      {/* QR Code Container */}
      <div className="relative bg-white p-8 rounded-2xl shadow-xl border-4 border-teal-500">
        <img 
          src={qrCodeUrl}
          alt="Fluffy Pets QR Code - Scan to visit our website"
          className="object-contain"
          style={{ width: `${size}px`, height: `${size}px` }}
        />
        <div className="absolute -bottom-3 left-1/2 transform -translate-x-1/2 bg-teal-600 text-white px-6 py-2 rounded-full font-bold text-sm shadow-lg whitespace-nowrap">
          SCAN ME! 📱
        </div>
      </div>

      {/* Download Button */}
      {showDownload && (
        <div className="mt-8 text-center">
          <button
            onClick={handleDownload}
            className="inline-flex items-center gap-2 bg-gradient-to-r from-teal-500 to-orange-500 text-white px-6 py-3 rounded-xl font-bold shadow-lg hover:shadow-2xl transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-download-line text-xl"></i>
            Download QR Code
          </button>
        </div>
      )}
    </div>
  );
}
